import * as React from 'react';

interface CalendarIconProps {
  date: Date;
}

export default function CalendarIcon(props: CalendarIconProps) {
  const dayOfMonth = props.date.getDate() + 1;

  return (
    <svg width="42px" height="42px" viewBox="0 0 47 51" version="1.1">
      <title>AutoPay Calendar Icon</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Pay-Your-Bill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Pay-Your-Bill---Quick-Pay---1"
          transform="translate(-350.000000, -1100.000000)"
          stroke="#46237A"
          strokeWidth="2.3"
        >
          <g id="Group-2" transform="translate(320.000000, 1070.000000)">
            <g id="Group" transform="translate(32.000000, 32.000000)">
              <g id="AutoPay-Calendar-Icon">
                <polygon
                  id="Stroke-1"
                  points="3.50117647 44.2329882 43.3037647 44.2329882 43.3037647 4.4304 3.50117647 4.4304"
                ></polygon>
                <polyline
                  id="Stroke-3"
                  points="39.9082588 46.6711765 39.9082588 47.6276471 0.105670588 47.6276471 0.105670588 7.82505882 1.2252 7.82505882"
                ></polyline>
                <path
                  d="M31.5252706,4.31992941 C31.5252706,1.99263529 32.5819765,0.105811765 33.8864471,0.105811765 C35.1895059,0.105811765 36.2462118,1.99263529 36.2462118,4.31992941 C36.2462118,6.64722353 35.1895059,8.53404706 33.8864471,8.53404706"
                  id="Stroke-4"
                ></path>
                <path
                  d="M10.0399765,4.31992941 C10.0399765,1.99263529 11.0973882,0.105811765 12.4011529,0.105811765 C13.7049176,0.105811765 14.7616235,1.99263529 14.7616235,4.31992941 C14.7616235,6.64722353 13.7049176,8.53404706 12.4011529,8.53404706"
                  id="Stroke-5"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
      <text
        x="50%"
        y="28"
        fontFamily="'proximanova_medium', Gotham, Montserrat, Trebuchet, sans-serif"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="#46237A"
        fontSize="24px"
      >
        {dayOfMonth < 10 ? `0${dayOfMonth}` : dayOfMonth}
      </text>
    </svg>
  );
}
